import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
@Injectable({
  providedIn: 'root',
})
export class CustomKeycloakService {
  constructor(protected keycloakService: KeycloakService) {}

  logout() {
    this.keycloakService.logout(window.location.origin + '/back-office/dashboard');
  }
}
